import {Component, computed, inject, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {MessageModule} from 'primeng/message';
import {of} from 'rxjs';
import {DirectusService} from '@frontend/directus';
import {rxResource} from '@angular/core/rxjs-interop';
import {catchError} from 'rxjs/operators';
import {
  ModuleNonHrIntegrationSystemRecording,
  OfficeSystemRecordingToolIntegrationsResponse,
} from '@frontend/shared';
import {CardTitleComponent} from '../../../../../../../../shared/components/header/card-title/card-title.component';
import {LoadingComponent} from '../../../../../../../../shared/components/loading/loading.component';
import {ModuleIntegrationPanelComponent} from '../module-integration-panel/module-integration-panel.component';
import {FixedValueType} from '../../../shared/system-flow.types';

@Component({
  selector: 'app-system-flow',
  imports: [
    TranslocoPipe,
    MessageModule,
    LoadingComponent,
    ModuleIntegrationPanelComponent,
    CardTitleComponent,
  ],
  templateUrl: './system-flow.component.html',
})
export class SystemFlowComponent {
  readonly projectId = input.required<number>();
  readonly isReadOnly = input<boolean>(false);

  readonly integrationSystemRecordings =
    input.required<OfficeSystemRecordingToolIntegrationsResponse>();

  private readonly directusService = inject(DirectusService);

  readonly dataDomainResource = rxResource({
    stream: () =>
      this.directusService
        .loadDirectusDropdown(FixedValueType.DATA_DOMAIN)
        .pipe(catchError(() => of([]))),
  });
  readonly dataDomainOptions = computed(() => this.dataDomainResource.value() ?? []);

  readonly integrationTypeDropdownResource = rxResource({
    stream: () =>
      this.directusService
        .loadDirectusDropdown(FixedValueType.INTEGRATION_TYPE)
        .pipe(catchError(() => of([]))),
  });
  readonly integrationTypeOptions = computed(
    () => this.integrationTypeDropdownResource.value() ?? [],
  );

  protected readonly moduleFunctionsResource = rxResource({
    stream: () => this.directusService.loadModuleFunctions(),
  });

  protected readonly moduleNonHrFunctionsResource = rxResource({
    stream: () => this.directusService.loadNonHrSystems(),
  });

  officeModuleHrIntegrations = computed(() => {
    return this.integrationSystemRecordings().officeModuleHrIntegrations ?? [];
  });

  officeModuleNonHrIntegration = computed(() => {
    return this.integrationSystemRecordings().officeModuleNonHrIntegrations ?? [];
  });

  noData = computed(() => {
    const hrCount = this.officeModuleHrIntegrations().length;
    const nonHrCount = this.officeModuleNonHrIntegration().length;
    return hrCount + nonHrCount === 0;
  });

  protected moduleNonHrIntegrationSystemRecordings(
    officeId: number,
  ): ModuleNonHrIntegrationSystemRecording[] {
    const current = this.officeModuleNonHrIntegration();
    if (!current || !Array.isArray(current)) {
      return [];
    }
    return current
      .filter((officeNonHrModule) => officeNonHrModule?.officeId === officeId)
      .flatMap((item) => item?.moduleNonHrIntegrationSystemRecordings ?? []);
  }
}
